import { Component, Input } from '@angular/core';

@Component({
  selector: 'mbc-single-step',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" [attr.width]="width" [attr.height]="height" viewBox="0 0 8 8" fill="none">
      <circle *ngIf="active" cx="4" cy="4" r="4" fill="#47BBC8" />
      <circle *ngIf="!active" cx="4" cy="4" r="4" fill="#CFD1D3" />
    </svg>
  `,
  styleUrls: ['./single-step.component.scss'],
})
export class SingleStepComponent {
  @Input() height = '8';
  @Input() width = '8';
  @Input() active: boolean | undefined;
}
